module.exports = __webpack_public_path__ + "img/hg-ida.09210fec.svg";